import type { GetActorQuery } from '@components/WithUser/WithUser.graphql';
import type { FirebaseUser } from '@modules/firebase';
import { createContext, useContext } from 'react';
import type { BBOrg, StripeSubscription, User, UserTags } from 'types';

export interface UserContextValues {
  identity: FirebaseUser | undefined;
  user: User | undefined;
  userTags: UserTags | undefined;
  userSubscriptions: StripeSubscription[];
  org: BBOrg | undefined;
  loading: boolean;
  actor: GetActorQuery['actor'] | undefined;
}

const initialContext = {
  identity: undefined,
  user: undefined,
  userTags: undefined,
  userSubscriptions: [],
  org: undefined,
  actor: undefined,
  loading: true,
};

export const UserContext = createContext<UserContextValues>(initialContext);

/**
 * If the user is authenticated with firebase this will fetch all their details
 */
export const useUser = (): UserContextValues => useContext(UserContext);
